var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.295 18.318a2.114 2.114 0 0 1-2.113 2.114H2.818a2.114 2.114 0 0 1-2.113-2.114v-15.5C.705 1.65 1.65.705 2.818.705h25.364c1.167 0 2.113.945 2.113 2.113v15.5z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeWidth: 2,
    d: "M1 1h29v19H1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeWidth: 2,
    d: "M1 1l14.5 11L30 1"
  }))));
}

export default SvgIconMail;